var t=t=>{const[e,a]=t.split(/\.(?=[^.]+$)/);return e.length<=50?t:e.slice(0,50)+"...."+a};export{t as default,t as getShortName};
//# sourceMappingURL=getShortName.js.map